import React from 'react';
import { Container, Grid, Card, CardContent, Typography, Avatar, Divider, Box } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const founders = [
  {
    name: "Mr. S.P. Singh",
    img: "https://via.placeholder.com/150",
    description: "With 58 years of experience, Mr. Singh is a well-known entity in the boiler field, recognized for providing the best boiler efficiency solutions and practical boiler designs."
  },
  {
    name: "Mr. Yogesh Bakshi",
    img: "https://via.placeholder.com/150",
    description: "Mr. Yogesh Bakshi has been nourishing his expertise for 30 years. He oversees mechanical and workshop progressions, ensuring perfection in on-site jobs."
  }
];

const AboutUsContent = () => {
  return (
    <Box sx={{ bgcolor: '#0A1929', color: '#E3F2FD', minHeight: '100vh', py: 4 }}>
      <Container maxWidth="lg">
        
        {/* About Us Section */}
        <Box textAlign="center" mb={4}>
          <Typography variant="h4" fontWeight="bold" color="#90CAF9">About Us</Typography>
          <Typography variant="body1" sx={{ mt: 1, color: '#BBDEFB' }}>
            We are a team dedicated to providing innovative solutions in the boiler industry, striving for excellence in every project.
          </Typography>
        </Box>

        {/* Founders Section */}
        <Typography variant="h5" fontWeight="bold" textAlign="center" color="#64B5F6" gutterBottom>
          Our Founders
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {founders.map((founder, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  p: 2, 
                  boxShadow: 4, 
                  borderRadius: 3, 
                  bgcolor: '#1E3A5F', 
                  transition: '0.3s',
                  '&:hover': { transform: 'scale(1.03)', boxShadow: 6 }
                }}
              >
                <Avatar src={founder.img} alt={founder.name} sx={{ width: 80, height: 80, mr: 2, bgcolor: '#90CAF9' }} />
                <CardContent>
                  <Typography variant="h6" fontWeight="bold" color="#E3F2FD">{founder.name}</Typography>
                  <Typography variant="body2" sx={{ color: '#BBDEFB' }}>{founder.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Contact Section */}
        <Box mt={6} p={4} bgcolor="#1565C0" borderRadius={2} textAlign="center" boxShadow={5}>
          <Typography variant="h5" fontWeight="bold" color="#E3F2FD">Contact Person</Typography>
          <Divider sx={{ my: 2, bgcolor: '#E3F2FD' }} />

          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" fontWeight="bold" color="#E3F2FD">Mr. Yogesh Bakshi</Typography>
              <Typography variant="body2" sx={{ color: '#BBDEFB' }}>
                <PhoneIcon sx={{ verticalAlign: 'middle', mr: 1 }} /> 9896070515
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="h6" fontWeight="bold" color="#E3F2FD">Mr. S.P. Singh</Typography>
              <Typography variant="body2" sx={{ color: '#BBDEFB' }}>
                <PhoneIcon sx={{ verticalAlign: 'middle', mr: 1 }} /> 9896051370
              </Typography>
            </Grid>
          </Grid>

          <Box mt={3}>
            <Typography variant="body1">
              <EmailIcon sx={{ verticalAlign: 'middle', mr: 1, color: '#E3F2FD' }} />
              <a href="mailto:modern_boilers@rediffmail.com" style={{ textDecoration: 'none', color: '#E3F2FD' }}>
                modern_boilers@rediffmail.com
              </a>
            </Typography>
          </Box>
        </Box>

      </Container>
    </Box>
  );
};

export default AboutUsContent;
